module.exports = __webpack_public_path__ + "img/orden_papas.c2ceee1a.jpeg";